/** Example from `ISSUE_CODE_NAV_GROUP_WIDTH` comment — longest realistic NCR code. */
export const ISSUE_NCR_NUMBER_WIDTH_FALLBACK = '2025/ENV/KTULA/de9f';

function measureTextWidth(
  text: string,
  fontFamily: string,
  fontSizePx: number
): number {
  if (typeof document === 'undefined') {
    return text.length * 8;
  }

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (!context) {
    return text.length * 8;
  }

  context.font = `600 ${fontSizePx}px ${fontFamily}`;
  return context.measureText(text).width;
}

/** Matches `issueCodeNavTypographySx` (fontWeight 600). */
export function measureIssueNcrNumberWidth(
  ncrNumber: string,
  fontFamily: string,
  fontSizePx: number
): number {
  return Math.ceil(measureTextWidth(ncrNumber, fontFamily, fontSizePx));
}
